let radioButtons = document.querySelectorAll('input[type="radio"][name="note"]');
let dynamicCheckoutButton = document.querySelector('.cart__dynamic-checkout-buttons.additional-checkout-buttons');

radioButtons.forEach(radioButton => {
    radioButton.addEventListener('change', () => {
        if (radioButton.checked) {
            dynamicCheckoutButton.style.display = 'block';
        } else {
            dynamicCheckoutButton.style.display = 'none';
        }
    });
});


window.onload = function recoverDynamicCheckoutState() {
    radioButtons.forEach(radioButton => {
        if (radioButton.checked) {
            dynamicCheckoutButton.style.display = 'block';
        } else {
            dynamicCheckoutButton.style.display = 'none';
        }
    });
};